import { render, staticRenderFns } from "./Home5.vue?vue&type=template&id=f51ac74e&scoped=true&"
import script from "./Home5.vue?vue&type=script&lang=js&"
export * from "./Home5.vue?vue&type=script&lang=js&"
import style0 from "./Home5.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Home5.vue?vue&type=style&index=1&id=f51ac74e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51ac74e",
  null
  
)

export default component.exports